import _ from 'lodash';
import $$api from 'models/api';
import { useEffect, useState } from 'react';

import HookAutocompleteFormControl from 'components/HookFormControl/Autocomplete/HookAutocompleteFormControl';

import useDebounce from 'hooks/useDebounce';

import { type AddressSuggestion } from 'types/zod/address-suggestion';

type TProps = {
    state?: string;
    [key: string]: any;
};

const HookAddressAutocompleteFormControl = (props: TProps) => {
    const { state } = props;

    const [addressSuggestions, setAddressSuggestions] = useState([] as AddressSuggestion[]);
    const [value, setValue] = useState(``);
    const debouncedValue = useDebounce(value);

    useEffect(() => {
        (async () => {
            if (!_.isEmpty(debouncedValue)) {
                const result = await $$api.participants.lookupAddressesFx({ search: value, state });
                setAddressSuggestions(result.suggestions || []);
            }
        })();
    }, [debouncedValue, state]);

    const getFullAddressLine = (item: AddressSuggestion) => {
        return [item.street_line, item.secondary, item.city, item.state, item.zipcode].join(' ');
    };

    return (
        <HookAutocompleteFormControl
            {...props}
            maxLength={60}
            items={addressSuggestions}
            getItemValue={({ street_line }: AddressSuggestion) => street_line}
            renderItem={(item: AddressSuggestion, isHighlighted: boolean) => (
                <div style={{ background: isHighlighted ? 'lightgray' : 'white' }} key={getFullAddressLine(item)}>
                    {getFullAddressLine(item)}
                </div>
            )}
            value={value}
            onChange={(e: any) => setValue(e.target.value.trim())}
        />
    );
};

export default HookAddressAutocompleteFormControl;
